import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEye = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 13,
	viewBox: "0 0 18 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.32675 8.32393C2.1031 4.59586 5.34852 1.94694 8.99918 1.94694C12.6487 1.94694 15.8941 4.59586 16.6716 8.32393C16.7024 8.47186 16.7907 8.6015 16.9171 8.68433C17.0435 8.76717 17.1976 8.7964 17.3455 8.7656C17.4934 8.73481 17.6231 8.64651 17.7059 8.52013C17.7887 8.39375 17.818 8.23964 17.7872 8.09171C16.9027 3.85138 13.2031 0.808594 8.99918 0.808594C4.79528 0.808594 1.09567 3.85138 0.211178 8.09171C0.180383 8.23964 0.209617 8.39375 0.292447 8.52013C0.375278 8.64651 0.50492 8.73481 0.652855 8.7656C0.800789 8.7964 0.954898 8.76717 1.08128 8.68433C1.20766 8.6015 1.29596 8.47186 1.32675 8.32393ZM8.98779 4.22362C10.0445 4.22362 11.0579 4.64338 11.805 5.39056C12.5522 6.13775 12.972 7.15114 12.972 8.20782C12.972 9.26449 12.5522 10.2779 11.805 11.0251C11.0579 11.7723 10.0445 12.192 8.98779 12.192C7.93112 12.192 6.91772 11.7723 6.17054 11.0251C5.42336 10.2779 5.0036 9.26449 5.0036 8.20782C5.0036 7.15114 5.42336 6.13775 6.17054 5.39056C6.91772 4.64338 7.93112 4.22362 8.98779 4.22362Z",
		fill: "#6A707C"
	})
});
export default SvgEye;
